module.exports = __webpack_public_path__ + "img/bookmark_I.75eca597.svg";